import { API } from "constants/RestApi";
import { useBaseAction } from "./index";
import { ITimeZones } from "../../core/types/entities/IItem";

const useAppSettings = () => {
  const { request } = useBaseAction();

  const getTimeZones = async () => {
    return (await request({
      method: "GET",
      url: API.APP_SETTINGS_TIMEZONES,
    })) as ITimeZones[];
  };

  return { getTimeZones };
};

export default useAppSettings;
